import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/orders/page', data, {
    trim: true
  })
}
export function logListPage (data) {
  return request.post('/business/orderLog/page', data, {
    trim: true
  })
}

export function getById (id) {
  return request.get(`/business/orders/detail/${id}`)
}

export function exportExcel (data) {
  return request.post('/business/orders/exportExcel', data, {
    download: true,
    trim: true
  })
}
export function dispatch (data) {
  return request.post('/business/orders/dispatch', data)
}
